module.exports = __webpack_public_path__ + "static/media/GOLD-BNB.d6f5983a.png";